import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import loadable from '@loadable/component';

import { relativePath } from 'core/config/env';
import userTypes from 'core/constants/userTypes';
import Preloader from 'components/Preloader';
import { isMobile, isIE } from 'react-device-detect';

const AsyncUserPage = loadable(({ userType }) => {
  const type = userTypes[userType];
  if (isMobile || isIE) return import('apps/notSupported.app');
  return userTypes[userType] ? import(`apps/${type}.app`) : import('apps/notAuthorized.app');
});

type Props = {
  sessionStore: {
    getCurrentUser: any,
    currentUser: {
      type: string
    }
  }
};

@inject('sessionStore')
@observer
class App extends Component<Props> {
  async componentDidMount() {
    const { sessionStore: { getCurrentUser } } = this.props;

    await getCurrentUser();
  }

  render() {
    const { sessionStore: { currentUser } } = this.props;
    const pathnameLocale = window.location.pathname.substring(1, 3);
    const locale = ['de', 'en', 'fr', 'it'].includes(pathnameLocale) ? pathnameLocale : 'de';

    if (!currentUser) {
      return <Preloader />;
    }

    return (
      <BrowserRouter basename={`/${locale}${relativePath}`}>
        <AsyncUserPage userType={currentUser.type} />
      </BrowserRouter>
    );
  };
};

export default App;
